<div class="flex items-center gap-3 p-3 rounded-xl border border-surface-200 dark:border-surface-700/50 bg-surface-0 dark:bg-surface-900">

  <!-- Status dot + label -->
  <div class="flex items-center gap-2 min-w-0">
    <span class="relative flex h-2.5 w-2.5 shrink-0">
      @if (isClockedIn()) {
        <span class="punch-status-dot-ping"></span>
        <span class="punch-status-dot"></span>
      } @else {
        <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-surface-300 dark:bg-surface-600"></span>
      }
    </span>
    <div class="flex flex-col leading-tight">
      <span class="text-xs font-semibold text-text-main">
        {{ isClockedIn() ? 'On Shift' : 'Not Clocked In' }}
      </span>
      @if (isClockedIn()) {
        <span class="punch-status-timer">
          {{ elapsed() }}
        </span>
      } @else {
        <span class="text-xs text-text-muted">
          {{ clockInTime() ? ('In at ' + (clockInTime() | date:'HH:mm')) : 'Ready to punch' }}
        </span>
      }
    </div>
  </div>

  <!-- Divider -->
  <div class="w-px h-8 bg-surface-200 dark:bg-surface-700 shrink-0"></div>

  <!-- Action button -->
  @if (!isClockedIn()) {
    <p-button
      label="Clock In"
      icon="pi pi-play-circle"
      severity="success"
      size="small"
      [loading]="isLoading()"
      [disabled]="isLoading()"
      (onClick)="clockIn()"
      styleClass="text-xs font-semibold" />
  } @else {
    <p-button
      label="Clock Out"
      icon="pi pi-stop-circle"
      severity="danger"
      size="small"
      [loading]="isLoading()"
      [disabled]="isLoading()"
      (onClick)="clockOut()"
      styleClass="text-xs font-semibold" />
  }

</div>
